;(function () {
  'use strict'

  angular
    .module('contrast.compliance-policy')
    .factory(
      'compliancePolicyApiConfig',
      function compliancePolicyApiConfigFactory($http, $q, UserService) {
        'ngInject'

        return {
          getPolicies: getPolicies,
          getPolicy: getPolicy,
          createPolicy: createPolicy,
          updatePolicy: updatePolicy,
          removePolicy: removePolicy,
          togglePolicyStatus: togglePolicyStatus
        }

        function getPolicies(limit, offset, searchKey, sortRow) {
          var httpTimeout = $q.defer(),
            request = $http({
              method: 'get',
              url: UserService.buildAPIUrl('/policy/compliance'),
              params: {
                limit: limit,
                offset: offset,
                q: searchKey,
                sort: sortRow
              },
              timeout: httpTimeout.promise
            })

          request._httpTimeout = httpTimeout
          return request
        }

        function getPolicy(policyId) {
          return $http.get(
            UserService.buildAPIUrl('/policy/compliance/' + policyId)
          )
        }

        function createPolicy(data) {
          return $http.post(UserService.buildAPIUrl('/policy/compliance'), data)
        }

        function updatePolicy(policyId, data) {
          return $http.put(
            UserService.buildAPIUrl('/policy/compliance/' + policyId),
            data
          )
        }

        function removePolicy(policyId) {
          return $http['delete'](
            UserService.buildAPIUrl('/policy/compliance/' + policyId),
            { headers: { 'Content-Type': 'application/json' } }
          )
        }

        function togglePolicyStatus(policyId) {
          return $http.put(
            UserService.buildAPIUrl(
              '/policy/compliance/' + policyId + '/status'
            )
          )
        }
      }
    )
})()
